// Generated by pnpm icons:generate. Edit native source assets and semantic roles, not this file.
import { createCoreLineIcon } from '../CoreLineIcon';
export const MenuIcon = /*#__PURE__*/ createCoreLineIcon(
  'menu',
  '0 0 14 14',
  '<g><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M13.5 2H0.5" stroke-width="1"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M13.5 7H0.5" stroke-width="1"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M13.5 12H0.5" stroke-width="1"></path></g>',
);
